<template>
	<v-container fluid>
		<v-col cols="9" sm="6" md="4" class="ml-auto mr-auto">
			<v-card class="elevation-2 px-5 rounded-lg py-7 mt-10">
				<login-form></login-form>
			</v-card>
		</v-col>
	</v-container>
</template>

<script>
	import LoginForm from '@/components/auth/LoginForm.vue'

	export default {
		components: {
			LoginForm
		}
	}
</script>

<style scoped>

</style>